export default "__VITE_ASSET__228ba0f0__"